import { z } from "zod";

export const ReprogramQuotationTaskSchema = z.object({
  scheduledAt: z
    .string()
    .min(1, "Veuillez renseigner une date et une heure pour reprogrammer la tâche.")
});

export type ReprogramQuotationTaskSchema = z.infer<typeof ReprogramQuotationTaskSchema>;
